<template>
  <div class="z-live" :style="'min-height:' + minHeight + 'px'" @click="close()">
    <div>
      <div id="menu">
        <div class="Shutup" @click="shutup()">全局禁言</div>
        <div class="updateShutup" @click="updateShutup()">禁言半小时</div>
      </div>
    </div>

    <div class="banner">
      <img :src="banner.img_url" @click="jumpFn(banner.jump_url)" />
      <div class="analyst-box">
        <img :src="ad_wx.pr" class="xiaoxin" />
        <div class>
          <div class="analyst-name">逛球街-{{ ad_wx.username }}</div>
          <div class="describe">
            添加管理员“{{
              ad_wx.username
            }}”，免费为您开通智能AI，推荐人气专家，免费红单内料，并赠送666个逛球币。
          </div>
        </div>
      </div>
    </div>
    <div class="live-content">
      <div class="live-left">
        <div class="box_outer">
          <div class="box_top" v-html="detail.league"></div>
          <div class="info-box">
            <div class="teamname home_team">
              <span class="name" v-html="detail.home_team_zh"></span>
              <span class="img">
                <img :src="detail.home_logo" alt />
              </span>
            </div>
            <div class="league">
              <div class="box_bottom">
                {{ $format(detail.start_time_int, "YYYY年MM月DD日 HH:mm") }}
              </div>
              <div class="box_vs" :style="detail.state ? 'color:#E84D5B;' : 'color:#BBB;'">
                VS
              </div>
            </div>
            <div class="teamname">
              <span class="img">
                <img :src="detail.away_logo" alt />
              </span>
              <span class="name" v-html="detail.away_team_zh"></span>
            </div>
          </div>
        </div>
        <div class="novideo" v-show="novideo">
          视频已下架，请选其他视频观看！
        </div>
        <iframe id="iframe2" width="748" height="429" frameborder="no" scrolling="no" allow="autoplay; fullscreen"
          allowfullscreen></iframe>
        <!-- 178广告  30秒弹出-->
        <ad-popup></ad-popup>
      </div>
      <div class="live-right">
        <ChatRoom :curTv="currAnchor" :match="detail" />
        <!-- <div class="char-box">
          <div class="title">
            <span class="chatname">
              <img
                src="//static.fly2a.com/gqj_tv/image/chats.png"
                alt
                width="16px"
              />&ensp;
              <span>{{ detail.username ? detail.username : "" }}</span>
              <span>{{ detail.username ? "的" : "" }}聊天室</span>
            </span>
            <span class="count">
              <img
                src="//static.fly2a.com/006zhibo/image/eye.png"
                alt
                width="16px"
              />
              <span class="text">{{ viewerFn(detail.viewer) }}</span>
            </span>
          </div>
          <div class="msg-list">
            <div
              class="follow"
              @mousemove="qrcodeShow($event)"
              @mouseleave="qrcodeHide()"
            >
              <div class="anchor">
                <img :src="detail.face" alt />
                <span>
                  <span class="name">{{ detail.username }}</span>
                  <br />
                  <span class="wx" v-if="detail.wx_num">
                    <span>账号:{{ detail.wx_num }}</span>
                  </span>
                </span>
              </div>
              <div
                :class="detail.isnofollow ? 'follow_btn' : 'follow_btn active'"
                v-html="follow_html(detail.isnofollow)"
                @click="followFn()"
                v-if="detail.member_id != getCookie('member_id')"
              ></div>
              <div class="follow_msg" v-if="follow_msg">{{ follow_msg }}</div>
              <div class="wx_qrcode" v-show="detail.wx_code && qrcode_show">
                <div>
                  <img :src="detail.wx_code" alt />
                </div>
                <div class="wx_qrcode_title">
                  扫一扫
                  <br />加主播账号
                </div>
              </div>
            </div>
            <div>
              <span style="display: flex; flex-direction: row">
                <i class="iconfont hornicon" style="color: #e84d5d">&#xe8e8;</i
                >&ensp;
                <marquee class="horn" style="color: #e84d5d">{{
                  detail.room_notice || commonChatroomNotice
                }}</marquee>
              </span>
            </div>
            <ul id="dialog" class="per-content" style="min-height: 198px"></ul>
          </div>
          <div class="msg-post">
            <textarea
              class="msg-content"
              placeholder="请输入..."
              id="textarea"
            ></textarea>

            <div class="say-btn">
              <div class="shield" v-if="shield.show">
                <div @click="shieldFn()">
                  <span>
                    <i class="iconfont2" v-if="!shield.shieldALL"></i>
                  </span>
                  <img
                    src="//static.fly2a.com/006zhibo/image/checked.png"
                    alt
                    v-if="shield.shieldALL"
                    width="16px"
                  />
                  <span>屏蔽所有入场消息</span>
                </div>
              </div>
              <img
                :src="
                  shield.shieldALL || shield.shieldYK
                    ? '//static.fly2a.com/gqj_tv/image/shield2.png'
                    : '//static.fly2a.com/gqj_tv/image/shield1.png'
                "
                @click="shield.show = !shield.show"
                width="22px"
              />
              <i class="iconfont btn btn-default face-btn face pull-left"
                >&#xe656;</i
              >
              <input
                type="submit"
                class="btn btn-default submit-btn"
                value="发表"
                id="subBtn"
                @click="onSubmit()"
              />
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import {
//   onChatroomConnect,
//   onChatroomDisconnect,
//   onSubmit,
//   markChatroomGaglist,
//   updateChatroomMemberTempMute,
//   scrollToLocation,
// } from "@/assets/js/chatroom.js";
import ChatRoom from "@/components/chatroom-v2/index"
import adPopup from "@/components/components/adPopup";
export default {
  components: {
    ChatRoom,
    adPopup
  },
  data() {
    return {
      ids: this.$route.query.id,
      ad_wx: {
        pr: "//static.fly2a.com/static/image/fbCommon/xiaoxin.jpg",
        name: "gqj8800",
        username: "漠柯",
      },
      headCon: headCon(),
      netease_im_token: 0,
      shield: {
        shieldYK: false,
        shieldALL: false,
        show: false,
      },
      currAnchor: {
        member_id: 0,
        name: "公共",
        roomid: 0,
        room_id: 0,
        room_user_num: "",
        face: "",
        isnofollow: 1,
        wx_num: "",
        type: 0,
        wx_code: "",
        qrcode: ''
      },
      banner: {
        jump_url: "#",
        img_url: "//static.fly2a.com/gqj_tv/banner.png",
      },
      novideo: 0,
      detail: {
        isnofollow: 1,
      },
      qrcode_show: 0,
      minHeight: "",
      follow_msg: "",
      follow: [],
    };
  },
  created() {
    this.getDetailFn();
    //			this.getAd();
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  mounted() {
    var shield = window.localStorage.getItem("shield");
    if (shield == 1) {
      this.shield.shieldALL = true;
    }
    this.minHeight = $(window).height() - 110;
    this.chat_click();
  },
  methods: {
    followFn() {
      if (!this.netease_im_token || this.netease_im_token == 1) {
        if (!this.netease_im_token) {
          $(".loading").show();
          $(".loading_content1").show();
          $(".zhuce").show();
          $(".loading_content2").hide();
          //						$(".authimg").attr("src", COMMOND.NEW_BASE_URL  + "get_img_code?"+Math.random()*10000);
        }
        return;
      }
      var token = this.getCookie("token");
      var type = 0;
      axios
        .post(
          COMMOND.NEW_BASE_URL + "follow_anchor",
          {
            member_id: this.detail.member_id,
            is_follow: this.detail.isnofollow,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (this.detail.isnofollow) {
              this.detail.isnofollow = 0;
              this.follow.push(this.detail.member_id);
              this.followMsg("关注成功");
            } else {
              this.detail.isnofollow = 1;
              this.follow.splice(this.follow.indexOf(this.detail.member_id), 1);
              this.followMsg("取消关注成功");
            }
          } else {
            this.followMsg(res.data.msg);
          }
        });
    },
    followMsg(msg) {
      var that = this;
      this.follow_msg = msg;
      setTimeout(function () {
        that.follow_msg = "";
      }, 1500);
    },
    getFollowAnchor() {
      var token = this.getCookie("token");
      if (!token) {
        return;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "get_anchor_ids", {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          var data = res.data.data;
          this.follow = data;
          //		    		for (var i=0; i<data.length; i++) {
          //		    			this.follow.push(data[i].member_id);
          //		    		}
          if (this.follow.indexOf(this.detail.member_id) != -1) {
            this.detail.isnofollow = 0;
          }
        });
    },
    follow_html(type) {
      if (type) {
        return '<span class="follow_add">+</span><span>关注</span>';
      }
      return "已关注";
    },
    qrcodeShow(e) {
      var positionX = e.pageX - $(".follow").offset().left; //获取当前鼠标相对img的X坐标
      if (positionX > 0) {
        this.qrcode_show = 1;
        //   				$(".wx_qrcode").css("left",(positionX-54)+"px")
      } else {
        this.qrcode_show = 0;
      }
    },
    qrcodeHide() {
      this.qrcode_show = 0;
    },
    shutup() {
      $("#menu").hide();
      var keys = $("#menu").attr("keys");
      var [platform, uid] = keys.replace(/dev_/, '').split('_')
      axios
        .post(
          COMMOND.NEW_BASE_URL + "mute",
          {
            platform, uid
          },
          {
            headers: {
              Authorization: this.getCookie("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            alert("全局禁言成功");
          } else {
            alert(res.data.msg);
          }
        });
    },
    updateShutup() {
      $("#menu").hide();
      var keys = $("#menu").attr("keys");
      updateChatroomMemberTempMute(keys, true);
    },
    close() {
      $("#menu").hide();
    },
    getAd() {
      var url = COMMOND.NEW_BASE_URL + "get_ad_list";
      axios.get(url).then((res) => {
        var data = res.data;
        if (data.code == 200) {
          var top = data.data.top;
          if (top && top.img_url) {
            this.banner = {
              jump_url: top.jump_url,
              img_url: top.img_url,
            };
          }
        }
      });
    },
    jumpFn(jump_url) {
      if (jump_url && jump_url != "#") {
        window.open(jump_url);
      }
    },
    getDetailFn() {
      if (!this.ids) {
        window.location.href = "/zonghe";
        return;
      }
      axios
        .get(COMMOND.NEW_BASE_URL + "get_synthesis_pcdetail/" + this.ids)
        .then((res) => {
          res.data.data.isnofollow = 1;
          this.detail = res.data.data;
          this.currAnchor.member_id = res.data.data.member_id
          this.currAnchor.name = res.data.data.name || res.data.data.username
          this.currAnchor.room_id = res.data.data.ws_room_id || res.data.data.roomid
          this.currAnchor.roomid = res.data.data.roomid
          this.currAnchor.room_user_num = res.data.data.room_user_num
          this.currAnchor.face = res.data.data.face
          this.currAnchor.isnofollow = res.data.data.isnofollow
          this.currAnchor.wx_num = res.data.data.wx_num
          this.currAnchor.type = res.data.data.type
          this.currAnchor.wx_code = res.data.data.wx_code
          this.currAnchor.qrcode = res.data.data.qrcode
          this.currAnchor.room_notice = res.data.data.room_notice;
          if (this.detail.ad_wx) {
            this.ad_wx = this.detail.ad_wx;
          }
          if (this.detail.ad) {
            this.banner = {
              jump_url: this.detail.ad.jump_url,
              img_url: this.detail.ad.img_url,
            };
            this.banner.img_url =
              "https://static.fly2a.com/gqj_tv/live/banner.png";
          }
          if (this.detail.tvid) {
            $("#iframe2").attr("src", COMMOND.VIDEO_URL + this.detail.tvid);
          } else {
            this.novideo = 1;
          }
          if (this.detail.roomid) {
            // this.createdChatroom(this.detail.roomid);
          } else {
            layer.tips("暂无聊天室", $("#textarea"), {
              tips: [4, "#e24949"],
              time: 3000,
            });
          }
          this.getFollowAnchor();
          this.$nextTick(function () {
            $("footer").show();
            $(".haed_zonghe").addClass("nuxt-link-exact-active");
          });
          //		    		this.setViewer(this.ids,(this.detail.type+2),this.detail.member_id)
        });
    },
    viewerFn(viewer) {
      if (viewer > 10000) {
        return (viewer / 10000).toFixed(2) + "万";
      } else {
        return viewer;
      }
    },
    shieldFn() {
      if (this.shield.shieldALL) {
        window.localStorage.setItem("shield", 0);
        //					$(".msg-list .per-content li.enter").css("display","block");
      } else {
        window.localStorage.setItem("shield", 1);
        //					$(".msg-list .per-content li.enter").css("display","none");
      }
      this.shield.shieldALL = !this.shield.shieldALL;
      this.shield.show = false;
      this.$nextTick(function () {
        scrollToLocation();
      });
    },
    onSubmit() {
      if (!this.netease_im_token || this.netease_im_token == 1) {
        if (!this.netease_im_token) {
          $(".loading").show();
          $(".loading_content1").show();
          $(".zhuce").show();
          $(".loading_content2").hide();
          $(".authimg").attr(
            "src",
            COMMOND.NEW_BASE_URL + "get_img_code?" + Math.random() * 10000
          );
        } else {
          layer.tips("暂无聊天室", $("#textarea"), {
            tips: [4, "#e24949"],
            time: 3000,
          });
        }
        return;
      }
      onSubmit();
    },
    chat_click() {
      var that = this;
      $(".face").click(function (event) {
        $(this).sinaEmotion($("textarea"));
        event.stopPropagation();
      });
      // 回车发送
      $("#textarea").on("keydown", function (e) {
        if (e.keyCode === 13 && !e.ctrlKey) {
          // 按enter键提交
          var nowTime = new Date().getTime();
          var clickTime = $(this).attr("ctime");
          if (clickTime != "undefined" && nowTime - clickTime < 3000) {
            //禁止连续发言
            layer.tips("客官,说话太快啦(つД`)", this, {
              tips: [4, "#e24949"],
              time: 3000,
            });
          } else {
            e.preventDefault();
            $("#subBtn").click();
            $(this).attr("ctime", nowTime);
          }
        }

        // 按ctrl+enter组合键换行
        if (e.keyCode === 13 && e.ctrlKey) {
          $(this).val(function (i, val) {
            return val + "\n";
          });
        }
      });
    },
    setViewer(tournament_id, type, member_id) {
      var url = COMMOND.NEW_BASE_URL + "viewer";
      axios
        .post(
          url,
          {
            tournament_id: tournament_id,
            type: type,
            member_id: member_id,
          },
          {
            headers: {
              clientType: "pc",
            },
          }
        )
        .then((res) => { });
    },
    createdChatroom(chatroomid) {
      if (!this.getCookie("yk_token") && !this.getCookie("netease_im_token")) {
        this.getykmsg(chatroomid);
        return;
      }
      var netease_im_token = this.getCookie("netease_im_token")
        ? this.getCookie("netease_im_token")
        : this.getCookie("yk_token");
      this.netease_im_token = this.getCookie("netease_im_token");
      sessionStorage.setItem("chatroomid", chatroomid);
      var member_id = this.getCookie("member_id")
        ? COMMOND.DEV + this.getCookie("member_id")
        : this.getCookie("yk_account");
      onChatroomConnect(member_id, netease_im_token, chatroomid, this.getykmsg);
      this.connectSocket("", (res) => {
        if (res.type == "mute") {
          res.data.forEach((id) => {
            $("#dialog [data-fromid$=" + id + "]").remove();
          });
        }
      });
    },
    getykmsg(chatroomid) {
      if (!this.getCookie("netease_im_token")) {
        axios.get(COMMOND.NEW_BASE_URL + "get_visitor").then((res) => {
          //			    		console.log(res)
          var data = res.data.data;
          this.setCookie("yk_name", data.nick_name);
          this.setCookie("yk_account", data.accid);
          this.setCookie("yk_token", data.token);
          this.createdChatroom(chatroomid);
        });
      }
    },
    setCookie(name, value) {
      document.cookie = name + "=" + value + ";path=/";
    },
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    },
  },
  metaInfo() {
    return {
      title: this.headCon["zonghe"]["title"],
      script: [
        {
          src: "/static/js/f-chat.js",
        },
        {
          src:
            "//static.fly2a.com/static/lib/chat/js/jquery-sinaEmotion-2.1.0.js",
        }, //聊天长连接
      ],
      link: [
        {
          rel: "stylesheet",
          href:
            "//static.fly2a.com/static/lib/chat/css/jquery-sinaEmotion-2.1.0.min.css",
        },
      ],
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["zonghe"]["keywords"],
        },
      ],
    };
  },
};
</script>

<style>
@import "../../assets/css/z-live.css";
</style>
